import * as ServiceAPI from "@services"
import * as constantsAPI from "@constants"
import axios from "axios"
import { cloneDeep, get, isEmpty } from "lodash"
import { API_KC_URL, API_PG_URL } from "../../utils/url"
const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}
const { headerAxios, API_BASE_URL, KC_API_BASE_URL } = ServiceAPI
const authHeaderAxios = axios.create()

export const createPaymentConfig = (body,headers) => {
  return headerAxios.post(API_PG_URL + API_END_POINTS.createPaymentConfig, body,{
    headers
  })
}

export const updatePaymentKey = (body, id,headers) => {
  return headerAxios.put(
    API_PG_URL + API_END_POINTS.updatePaymentKey + id,
    body,
    {
      headers
    }
  )
}

export const deletePaymentConfig = (id,headers) => {
  return headerAxios.put(API_PG_URL + API_END_POINTS.deletePaymentConfig + id, {
    updatedBy: localStorage.getItem("userName"),
  },
   {
    headers
  }
)
}

export const postRefundPayment = (id, data) => {
  return headerAxios.post(API_PG_URL + API_END_POINTS.refundPayment + id, data)
}

export const getPaymentConfig = (data,body={},headers) => {
  return headerAxios.post(API_PG_URL + API_END_POINTS.getPaymentConfig + data,body,{
    headers
  })
}
export const getPaymentKey = (data,headers) => {
  return headerAxios.get(API_PG_URL + API_END_POINTS.getPaymentKey + "/" + data,{
    headers:headers
  })
}
export const getCloverRegionsList = (headers) => {
  return headerAxios.get(API_PG_URL + API_END_POINTS.getCloverRegions,{
    headers:headers
  })
}
export const checkRefund = (headers) => {
  return headerAxios.get(API_PG_URL + API_END_POINTS.checkRefund,{
    headers:headers
  })
}

